import React from "react";
import { useTranslation } from "react-i18next";

export const ModalTyC = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div style={overlayStyle} onClick={onClose} />

      {/* Modal */}
      <div style={modalStyle}>
        {/* Header */}
        <div style={headerStyle}>
          <h2 style={headerTitleStyle}>{t("modaltyc.titulo")}</h2>
          <button
            style={closeButtonStyle}
            onClick={onClose}
            aria-label={t("modaltyc.botoncerrar")}
          >
            &times;
          </button>
        </div>

        {/* Content */}
        <div style={contentStyle}>
          <div
            dangerouslySetInnerHTML={{
              __html: t("modaltyc.contenido")
            }}
          />
        </div>

        {/* Footer */}
        <div style={modalFooterStyle}>
          <button style={actionButtonStyle} onClick={onClose}>
            {t("modaltyc.botoncerrar")}
          </button>
        </div>
      </div>

      {/* Component-specific styles */}
      <style>{`
        /* Evita que el contenido del body haga scroll cuando el modal está abierto */
        body.modal-open {
          overflow: hidden;
        }
      `}</style>
    </>
  );
};

// Styles
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.5)",
  zIndex: 1000,
};

const modalStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "700px",
  maxHeight: "80vh",
  backgroundColor: "#fff",
  borderRadius: "8px",
  boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
  display: "flex",
  flexDirection: "column",
  zIndex: 1001,
};

const headerStyle = {
  padding: "16px 24px",
  borderBottom: "1px solid #eee",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const headerTitleStyle = {
  margin: 0,
  fontSize: "20px",
  color: "#333",
};

const closeButtonStyle = {
  fontSize: "24px",
  lineHeight: "1",
  background: "none",
  border: "none",
  cursor: "pointer",
  color: "#666",
};

const contentStyle = {
  padding: "16px 24px",
  overflowY: "auto",
  color: "#444",
  fontSize: "14px",
  lineHeight: "1.6",
};

const modalFooterStyle = {
  padding: "12px 24px",
  borderTop: "1px solid #eee",
  textAlign: "right",
};

const actionButtonStyle = {
  padding: "8px 16px",
  backgroundColor: "#222",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "14px",
};
